import React, { useEffect, useState } from 'react';
import { Divider } from "@heroui/react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import Label from '../components/Label';
import OwnershipsSelectbox from '../components/filter-detail/Ownerships-Selectbox';
import { difference } from 'lodash';
import { OwnershipFilter } from '../types/classes/OwnershipFilter';
import { useAppSelector } from '../../../core/rootHooks';
import { selectIsFiltersLoading } from '../filterSelectors';
import LoadingSpinner from '../../../shared/components/loading-spinner/LoadingSpinner';

interface IFilterOwnershipsSelectionProps {
    msiOwnerships: string[];
    ownershipFilter: OwnershipFilter;
    handleCloseFilterDetailOnClick: (isOpen: boolean) => void;
}

const FilterOwnershipsSelection: React.FC<IFilterOwnershipsSelectionProps> = ({ ...props }) => {
    const [rightItems, setRightItems] = useState<string[]>([]);
    const [selectedMsiOwnershipKeys, setSelectedMsiOwnershipKeys] = useState<Set<string>>(new Set([]));
    const [selectedFilterOwnershipKeys, setSelectedFilterOwnershipKeys] = useState<Set<string>>(new Set([]));
    const isFiltersLoading = useAppSelector(selectIsFiltersLoading);

    useEffect(() => {
        setSelectedMsiOwnershipKeys(new Set(props.ownershipFilter.ownerships));
        setRightItems(props.ownershipFilter.ownerships);
    }, [props.ownershipFilter.ownerships]);

    // Update selected keys when user selects a vessel or uploads a file by adding to already saved selected keys
    const updateSelectedMsiOwnershipKeys = (owners: string[]) => {
        setSelectedMsiOwnershipKeys(new Set(owners));        
        if (owners.length > 0) {
            const movedItems = Array.from(owners);
            setRightItems(movedItems);
            setSelectedMsiOwnershipKeys(new Set(movedItems))
            props.ownershipFilter.addOwnerships(movedItems);
        }
    }

    // Update selected keys when user selects a vessel or uploads a file by adding to already saved selected keys
    const updateSelectedFilterOwnershipKeys = (owners: string[]) => {
        setSelectedFilterOwnershipKeys(new Set(owners));
        if (owners.length > 0) {
            const movedItems = Array.from(owners);
            // setLeftItems([...leftItems, ...movedItems]);
            setRightItems(difference(rightItems, movedItems));
            props.ownershipFilter.removeOwnerships(movedItems);
        }
    }

    return (
        <div className='flex flex-col'>
            <div className="flex-initial" >
                <div className='px-3 py-1 items-center text-center'>
                    <Label title="Ownership" textSize="lg" />
                    <span className='cursor-pointer float-right' onClick={() => props.handleCloseFilterDetailOnClick(false)}>
                        <FontAwesomeIcon icon={faClose} size="sm" />
                    </span>
                </div>
            </div>
            <Divider className='w-auto mr-2 mt-1' />
            {isFiltersLoading === true ? <LoadingSpinner label='Ownership filters are loading' spinnerClassName='flex-auto w-96' /> :
                <div className="flex h-full overflow-y-hidden space-x-2 mt-2 mr-2">

                    <div className="flex flex-col space-y-2  ">
                        <Label title="MSI Ownership" textSize="sm" />
                        <OwnershipsSelectbox key="msi-ownerships" updateSelectedKeys={updateSelectedMsiOwnershipKeys}
                            hideSelectedIcon={false} selectionMode='multiple'
                            selectedKeys={Array.from(selectedMsiOwnershipKeys)} options={props.msiOwnerships} />
                    </div>

                    <div className="flex flex-col space-y-2">
                        <Label title="Filter Ownership" textSize="sm" />
                        <OwnershipsSelectbox key="filter-ownerships" updateSelectedKeys={updateSelectedFilterOwnershipKeys}
                            hideSelectedIcon={true} selectionMode='single'
                            emptyListMessage="There is no ownership in your filter. Ownerships won't be considered when you apply filter."
                            selectedKeys={Array.from(selectedFilterOwnershipKeys)} options={rightItems.sort()} />
                    </div>
                </div>}
        </div>
    );
};

export default FilterOwnershipsSelection;